import styled, { css } from 'styled-components';

export const CalendarWrapper = styled.div<{
  $maxWidth: number;
  $popup: boolean;
}>`
  padding: ${({ theme }) => theme.spacing(2)}px;
  max-width: ${({ theme, $maxWidth }) => theme.spacing($maxWidth)}px;

  ${({ $popup }) =>
    $popup &&
    css`
      margin-top: ${({ theme }) => theme.spacing(1)}px;
      border-radius: ${({ theme }) => theme.spacing(1.5)}px;
      background: ${({ theme }) => theme.mosaiq.colors.white};
      z-index: 10;
      box-shadow: ${({ theme }) => theme.mosaiq.elevation[2]};
    `}

  .react-calendar {
    padding: 0;

    .react-calendar__navigation__label {
      ${({ theme }) => theme.mosaiq.typography.title6({ fontWeight: 500 })};
      color: ${({ theme }) => theme.mosaiq.colors.passive};
      order: -1;
      text-align: left;
      padding-left: 0;
      background: transparent !important;
      border: 0;
      outline: none;
      cursor: pointer;

      &:hover,
      &:focus,
      &:active {
        background: transparent !important;
      }

      &:hover {
        color: ${({ theme }) => theme.mosaiq.colors.body};
      }
    }

    .react-calendar__navigation__prev2-button,
    .react-calendar__navigation__next2-button {
      display: none !important;
    }

    .react-calendar__navigation__label__labelText {
      display: flex;
      align-items: center;
    }

    .react-calendar__navigation {
      display: flex;
      align-items: center;
      margin-bottom: ${({ theme }) => theme.spacing(2)}px !important;
    }

    .react-calendar__navigation__arrow {
      background: transparent;
      min-width: ${({ theme }) => theme.spacing(3)}px !important;
      min-height: ${({ theme }) => theme.spacing(3)}px !important;
      width: ${({ theme }) => theme.spacing(3)}px !important;
      height: ${({ theme }) => theme.spacing(3)}px !important;
      border-radius: ${({ theme }) => theme.spacing(1)}px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 0;

      svg {
        min-width: ${({ theme }) => theme.spacing(2)}px !important;
        min-height: ${({ theme }) => theme.spacing(2)}px !important;
        width: ${({ theme }) => theme.spacing(2)}px !important;
        height: ${({ theme }) => theme.spacing(2)}px !important;
        color: ${({ theme }) => theme.mosaiq.colors.passive};
      }

      &:hover {
        background-color: ${({ theme }) => theme.mosaiq.colors.grey};
      }
    }

    .react-calendar__tile {
      background: transparent;
      border: 0;
      margin: 0;
      outline: none;
      cursor: pointer;

      &:disabled {
        pointer-events: none;
        background-color: transparent !important;

        abbr {
          background-color: transparent !important;
          color: ${({ theme }) => theme.mosaiq.colors.placeholder};
        }
      }
    }

    .react-calendar__year-view__months,
    .react-calendar__century-view__decades,
    .react-calendar__decade-view__years {
      .react-calendar__tile {
        min-height: ${({ theme }) => theme.spacing(5)}px !important;
        border-radius: ${({ theme }) => theme.spacing(1)}px;
        margin-bottom: ${({ theme }) => theme.spacing(1)}px !important;
        ${({ theme }) => theme.mosaiq.typography.title6({ fontWeight: 500 })};
        color: ${({ theme }) => theme.mosaiq.colors.passive};

        abbr {
          ${({ theme }) => theme.mosaiq.typography.title6({ fontWeight: 500 })};
          color: ${({ theme }) => theme.mosaiq.colors.passive};
        }

        &--hasActive {
          color: ${({ theme }) => theme.mosaiq.colors.black};

          abbr {
            color: ${({ theme }) => theme.mosaiq.colors.black};
          }
        }

        &:hover {
          color: ${({ theme }) => theme.mosaiq.colors.body};

          abbr {
            color: ${({ theme }) => theme.mosaiq.colors.body};
          }
        }
      }
    }

    .react-calendar__month-view__weekdays {
      margin-bottom: ${({ theme }) => theme.spacing(1)}px !important;
    }

    .react-calendar__month-view__weekdays__weekday {
      text-align: center;

      abbr {
        ${({ theme }) => theme.mosaiq.typography.body3()};
        color: ${({ theme }) => theme.mosaiq.colors.placeholder};
        text-decoration: none;
        font-style: italic;
      }
    }

    .react-calendar__month-view__days__day--neighboringMonth {
      abbr {
        color: ${({ theme }) => theme.mosaiq.colors.placeholder};
      }
    }

    .react-calendar__month-view__days {
      .react-calendar__tile {
        margin-bottom: ${({ theme }) => theme.spacing(1)}px !important;

        abbr {
          display: flex;
          align-items: center;
          justify-content: center;
          width: ${({ theme }) => theme.spacing(4)}px !important;
          height: ${({ theme }) => theme.spacing(4)}px !important;
          min-width: ${({ theme }) => theme.spacing(4)}px !important;
          min-height: ${({ theme }) => theme.spacing(4)}px !important;
          flex-basis: ${({ theme }) => theme.spacing(4)}px !important;
          ${({ theme }) => theme.mosaiq.typography.body3()};
          border-radius: ${({ theme }) => theme.spacing(1)}px;
        }

        &:hover {
          abbr {
            background-color: ${({ theme }) => theme.colors.grey};
          }
        }
      }

      .react-calendar__tile--now {
        abbr {
          color: ${({ theme }) => theme.colors.white};
          background: ${({ theme }) => theme.colors.black} !important;
          border-radius: ${({ theme }) => theme.spacing(1)}px;
        }
      }

      .react-calendar__tile--active {
        abbr {
          background: ${({ theme }) => theme.mosaiq.colors.grey20} !important;
        }

        &:hover,
        &:focus {
          abbr {
            background: ${({ theme }) => theme.mosaiq.colors.grey40} !important;
          }
        }
      }
    }
  }
`;
